import * as Err from '@fixtuur/error-context';
import * as TE from 'fp-ts/TaskEither';
import { pipe } from 'fp-ts/lib/function';
import * as Api from '../../api';
import * as Url from '../../api/url';
import { get as _get } from '../get';
import { post as _post } from '../post';
import { RequestError } from '../requestError';
const buildGetSelectionsUrl = (config, space, proposal) => Url.toString({
    base: config.compatibility,
    path: `/api/v1/${config.tenant}/selections`,
    query: { space, proposal: Api.Configuration.Selections.proposalToString(proposal) },
});
export const getSelections = (config, configurationSpaceId, proposal) => {
    return pipe(buildGetSelectionsUrl(config, configurationSpaceId, proposal), _get, TE.mapLeft(err => Err.construct(RequestError.FetchError, {
        error: err?.message,
    })));
};
const buildPostSelectionsUrl = (config, space) => Url.toString({
    base: config.compatibility,
    path: `/api/v1/${config.tenant}/selections`,
    query: { space },
});
export const postSelections = (config, configurationSpaceId, proposal) => {
    return pipe(_post(buildPostSelectionsUrl(config, configurationSpaceId), {
        proposals: Api.Configuration.Selections.proposalToString(proposal),
    }), TE.mapLeft(err => Err.construct(RequestError.FetchError, {
        error: err?.message,
    })));
};
